import { useMutation } from "@apollo/client";

import { SpeciesFormInputs } from "../../../components/SpeciesForm";
import { SettingsSpeciesEditRoute_UpdateDocument } from "../mutations.generated";

export default function useSettingsSpeciesEditRoute_Update() {
    const [mutate, { loading, error }] = useMutation(SettingsSpeciesEditRoute_UpdateDocument);

    const updateSpecies = (speciesId: string, input: SpeciesFormInputs) =>
        mutate({
            variables: { input: { ...input, speciesId } },
        });

    return {
        updateSpecies,
        loading,
        error,
    };
}
